import { useAppActions } from 'actions/app-actions';
import { useBrandActions } from 'actions/brand-actions';
import { useProfileActions } from 'actions/profile-actions';
import { useSessionActions } from 'actions/session-actions';
import AppErrorHandler from 'AppErrorHandler';

import { AppErrorStatusCode } from 'common/constants';
import { AppStateController } from 'common/controller/AppStateController';
import { IUserProfile } from 'common/interfaces/iprofile';
import UILogger, { LogRecordType, LogSeverityType } from 'common/utils/logger';
import { useEffect, useMemo, useState } from 'react';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { checkUserSession } from 'services/auth-service';
import { identifyAnalyticsUser } from 'services/analytics-service';
import { retrieveSelectedBrandId } from 'services/db-service';
// import {startEventListener} from 'services/rng-client/event-handler';
import { RootState, store, useAppSelector } from 'setup/store';

const AppInit = () => {
  const { init, setUserLoggedIn, setLoggedInUser, setAppInitialized } = useAppActions();
  const { setRoleAccessData, setSelectedBrand } = useSessionActions();
  const { loadAllBrands } = useBrandActions();
  const { setUserProfile, getUserProfile } = useProfileActions();
  const location = useLocation();
  const sdkConfig = useAppSelector((state) => state.appReducer.appConfig);
  const isUserLoggedIn = useAppSelector((state) => state.appReducer.isUserLoggedIn);

  const isAppInitialized = useAppSelector((state: RootState) => state.appReducer.isAppInitialized);

  const checkUserInfo = async () => {
    UILogger.log('init:', 'checking persisted user info: ');

    UILogger.log('init:', 'checking user session: ');
    const usr = await checkUserSession();
    UILogger.log('init:', 'Checking user session Done: ', usr?.data?.user);
    if (usr?.status.success && sdkConfig) {
      const localBrand = retrieveSelectedBrandId();
      if (localBrand && localBrand > 0) {
        await loadAllBrands(1, 100);
      }
      setLoggedInUser(usr.data.user as IUserProfile);
      setUserLoggedIn(true);
      setUserProfile(usr.data.user as IUserProfile);
      setRoleAccessData(usr.data.role);
      identifyAnalyticsUser(usr.data.user, usr.data.role?.roleName);
      if (usr.data.brands && usr.data.brands.length == 1) {
        setSelectedBrand(usr.data.brands[0]);
      }
    }
    setAppInitialized(true);
  };
  useEffect(() => {
    UILogger.log(
      {
        recordType: LogRecordType.ALL,
        severity: LogSeverityType.INFO,
        tag: 'init:',
      },
      'App launched',
    );
    // startEventListener();
    init(sdkConfig);

    // return () => apperanceChageListener.remove();
  }, []);

  useEffect(() => {
    UILogger.info('Initializing.....');
    const user = store.getState().appReducer.loggedInUser;
    const isLoggedIn = user && user.id > 0;
    if (!isLoggedIn && sdkConfig) {
      checkUserInfo();
    }
  }, [sdkConfig]);

  // useEffect(() => {
  //   setAppInitialized(true);
  // }, []);

  return (
    <>
      {isAppInitialized ? (
        <>
          {console.log('AppInit: rendering app init,isUserLoggedIn:', isUserLoggedIn)}
          {isUserLoggedIn ? (
            <Outlet />
          ) : (
            <Navigate
              to="/login"
              replace
              state={{ from: location }} // <-- current location so login can redirect back is desired
            />
          )}
          <AppErrorHandler />
        </>
      ) : (
        <div>Loading...</div>
      )}
    </>
  );
};

// const GlobalLoader = () => {
//   const { visible, message, disableBack } = useAppSelector((state) => state.appReducer.appLoaderState);
//   if (visible) return <Loader disableBack={disableBack} message={message} />;
//   return null;
// };

export default AppInit;
